<template>
  <div class="row">
    <div class="col-sm-12">
      <button class="btn btn-primary" @click.prevent="startChecklist()" :disabled="!hasTemplates">
        <font-awesome-icon :icon="['fas', 'circle-plus']" />
        Start Checklist
      </button>
      <span v-if="!hasTemplates" class="alert alert-info ml-3 message-component d-inline-block mt-sm-1 mt-md-0">
        <font-awesome-icon :icon="['fas', 'circle-exclamation']" /> No templates for this TxC and Organ combination
      </span>
      <span v-if="errorMessage" class="alert alert-danger ml-3 message-component d-inline-block mt-sm-1 mt-md-0">
        {{ errorMessage }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  hasTemplates: { required: true, type: Boolean },
  errorMessage: { required: false, type: String }
});

const emit = defineEmits(['start-checklist']);

function startChecklist() {
  emit('start-checklist');
}
</script>
